var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","row":""}},[_c('div',{attrs:{"mt-60":""}},[_c('v-progress-circular',{attrs:{"rotate":-90,"size":100,"width":15,"value":_vm.value,"color":"primary"}},[_vm._v("\n            "+_vm._s(_vm.value)+"\n            ")])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }